import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Modal,
  ActivityIndicator,
  ScrollView,
  RefreshControl,
  Dimensions,
  PixelRatio,
} from "react-native";
import React, { useContext, useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import FowardFlatArrow from "../../icons/FowardFlatArrow";
import MoneyIcon from "../../icons/MoneyIcon";
import SettingsIcon from "../../icons/SettingsIcon";
import LogOutIcon from "../../icons/LogOutIcon";
import useAuth from "../../hooks/useAuth";
import AppContext from "../../context/AppContext";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import UpdateProfilePage from "./UpdateProfilePage";
import UserProfileIcon from "../../icons/UserProfileIcon";
import UserGroupIcon from "../../icons/UserGroupIcon";
import FriendsListScreen from "../friendsListScreen/FriendsListScreen";
import AllTransactionHistories from "../allTransactionHistories/AllTransactionHistories";
import SettingsPage from "../settings/SettingsPage";
import BussinessPage from "../bussiness/BussinessPage";
import AsyncStorage from "@react-native-async-storage/async-storage";
import PullCREDsIcon from "../../icons/PullCREDsIcon";
import WordNotice from "../../alertComp/WordNotice";
import EmailIcon from "../../icons/EmailIcon";
import EmailIcon2 from "../../icons/EmailIcon2";
import FeedBackSupport from "../feedBackPage/FeedBackSupport";
import { Image } from "expo-image";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import IdeaLamp from "../../icons/IdeaLamp";
import { useNavigation } from "@react-navigation/native";

const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const dynamicThumbnailWidth = Math.round((width / BASE_WIDTH) * 60);
const dynamicThumbnailHeight = Math.round((width / BASE_WIDTH) * 60);

const ProfileBody = () => {
  // const { logout, isLoading } = useAuth()

  // const axiosPrivate = useAxiosPrivate()

  const { isLoading, logOut } = useContext(AppContext);

  const { username, firstname, lastname, pullCred, email, image, isBlockedAccess } = useAuth();

  const [showUpdateProfilePage, setShowUpdateProfilePage] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showBusiness, setShowBusiness] = useState(false);
  const [showAllTransactions, setShowAllTransactions] = useState(false);
  const [showFeedBacks, setShowFeedBacks] = useState(false);
  const [isWordNoticeVisible, setShowWordNotice] = useState(false);
  const [showMyBrands, setShowMyBrands] = useState(false);
  const [noticeMessage, setNoticeMessage] = useState("");

  const [retryCount, setRetryCount] = useState(0);

  const [imageKey, setImageKey] = useState(0);

  const [showFriendsListScreen, setShowFriendsListScreen] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);

  const navigation = useNavigation();

  const handleUpdateProfilePicture = async () => {
    if (isBlockedAccess) {
      setErrorMessage(
        "Please click the Buy button on the home page to verify your email before you proceed",
      );
      setIsErrorCompVisible(true);
    } else {
      setShowUpdateProfilePage(true);
    }
  };
  //console.log()
  const handleShowAllTransactionHistories = () => {
    setShowAllTransactions(true);
  };

  const handleOpenNotice = () => {
    setNoticeMessage(
      'PullCRED (Pull Credibility) - a measure of your "Doings" and influence on Meeza.',
    );
    setShowWordNotice(true);
  };

  // const getOptimizedCloudinaryUrl = (
  //     originalUrl,
  //     targetWidth,
  //     targetHeight
  // ) => {
  //     if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
  //         return originalUrl;
  //     }

  //     // The 'transformations' string includes the optimization flags
  //     const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_auto`;

  //     // Inject the transformations into the URL
  //     return originalUrl.replace(
  //         /upload\//,
  //         `upload/${transformations}/`
  //     );
  // };

  const getOptimizedCloudinaryUrl = (originalUrl, targetWidth, targetHeight) => {
    if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
      return originalUrl;
    }

    // 1. Define the transformations
    const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

    //const transformations = `w_${targetWidth},f_auto,q_90,dpr_auto`;

    const regex = /upload\/v\d+\//;

    return originalUrl.replace(regex, `upload/${transformations}/`);
  };

  const handleImageError = () => {
    if (retryCount < MAX_RETRIEZ) {
      // Increment the retry counter
      setRetryCount((prevCount) => prevCount + 1);

      // Force component re-render by changing the key
      setImageKey((prevKey) => prevKey + 1);

      ////console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
    } else {
      // Log final failure or set a state to show a permanent fallback icon
      ////console.log('Image failed to load after maximum retries.');
    }
  };

  const userImageThumbnailUrl = getOptimizedCloudinaryUrl(
    image,
    dynamicThumbnailWidth,
    dynamicThumbnailHeight,
  );

  if (isLoading) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator size={"large"} />
      </View>
    );
  }

  return (
    <View style={styles.profileContainer2}>
      <TouchableOpacity style={styles.profileHeaderContainer2} onPress={handleUpdateProfilePicture}>
        {image ? (
          <Image
            key={imageKey}
            source={{ uri: userImageThumbnailUrl }}
            // source={{ uri: userImageThumbnailUrl }}
            style={[styles.userImage2, { backgroundColor: "#d6d4d4ff" }]}
            contentFit="cover"
            cachePolicy="disk"
            onError={handleImageError}
          />
        ) : (
          <Image
            source={require("../../../assets/profile_image_holder.jpg")}
            style={styles.userImage2}
          />
        )}
        <Text style={styles.nameTxt}>{username}</Text>
        <Text style={styles.nameTxt2}>
          {firstname} {lastname}
        </Text>
        <Text style={styles.emailTxt}>{email}</Text>
        {/* <Text style={{ marginTop: 5, color: Colours.DARKLIGHTGRAY, fontSize: 13, fontFamily: 'Sen-Medium' }}>My Profile</Text> */}
      </TouchableOpacity>

      {errorMessage && (
        <View style={styles.errorMessage}>
          <Text style={styles.errorMessageTxt}>{errorMessage}</Text>
        </View>
      )}

      <TouchableOpacity
        style={styles.profileDataContainer}
        onPress={handleOpenNotice}
        disabled={isBlockedAccess}
      >
        <View style={styles.profileDataSubContainer}>
          <PullCREDsIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>DoingsCRED </Text>
            <Text
              style={{
                color: Colours.PRIMARY,
                fontSize: dynamicFontSize(20),
                fontFamily: "Sen-Bold",
              }}
            >
              {pullCred}
            </Text>
          </View>
        </View>
      </TouchableOpacity>

      {/*       
      <TouchableOpacity style={styles.profileDataContainer} onPress={handleUpdateProfilePicture}>
        <View style={styles.profileDataSubContainer}>
          <UserProfileIcon
            color={Colours.PRIMARY}
            height={dynamicSize(25)}
            width={dynamicSize(25)}
          />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>My Profile </Text>
            <FowardFlatArrow color={Colours.PRIMARY} />
          </View>
        </View>
      </TouchableOpacity> 
      */}

      <TouchableOpacity
        style={styles.profileDataContainer}
        onPress={() => {
          setNoticeMessage(
            "Log Out to change your username, note: you can only change your username once in 30days",
          );
          setShowWordNotice(true);
        }}
        // disabled={isBlockedAccess}
      >
        <View style={styles.profileDataSubContainer}>
          <UserGroupIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>Change username </Text>
            <FowardFlatArrow color={Colours.PRIMARY} />
          </View>
        </View>
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.profileDataContainer}
        onPress={() => {
          // setShowMyBrands(true);
          navigation.navigate("business_page");
        }}
        disabled={isBlockedAccess}
      >
        <View style={styles.profileDataSubContainer}>
          <IdeaLamp color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>My Brands </Text>
            <FowardFlatArrow color={Colours.PRIMARY} />
          </View>
        </View>
      </TouchableOpacity>
      {/* 
      <TouchableOpacity
        style={styles.profileDataContainer}
        onPress={handleShowAllTransactionHistories}
        disabled={isBlockedAccess}
      >
        <View style={styles.profileDataSubContainer}>
          <MoneyIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>Transfer History</Text>
            <FowardFlatArrow color={Colours.PRIMARY} />
          </View>
        </View>
      </TouchableOpacity>
 */}

      {/* <TouchableOpacity style={styles.profileDataContainer}
                onPress={() => setShowBusiness()}
            >
                <View style={styles.profileDataSubContainer}>
                    <Bussiness color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
                    <View style={styles.flatArrowContainer}>
                        <Text style={styles.textTxt}>Business</Text>
                        <FowardFlatArrow color={Colours.PRIMARY} />
                    </View>
                </View>
            </TouchableOpacity> */}

      <TouchableOpacity
        style={styles.profileDataContainer}
        onPress={() => setShowSettings()}
        disabled={isBlockedAccess}
      >
        <View style={styles.profileDataSubContainer}>
          <SettingsIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>Settings </Text>
            <FowardFlatArrow color={Colours.PRIMARY} />
          </View>
        </View>
      </TouchableOpacity>

      <TouchableOpacity style={styles.profileDataContainer} onPress={() => setShowFeedBacks(true)}>
        <View style={styles.profileDataSubContainer}>
          <EmailIcon2 color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>Feedback and support </Text>
            <FowardFlatArrow color={Colours.PRIMARY} />
          </View>
        </View>
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.profileDataContainer}
        // onPress={() => { handleLogOut }}
        onPress={async () => {
          // await AsyncStorage.removeItem(`hasViewedNotifications_${username}`);
          logOut();
        }}
      >
        <View style={styles.profileDataSubContainer}>
          <LogOutIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
          <View style={styles.flatArrowContainer}>
            <Text style={styles.textTxt}>LogOut </Text>
            <FowardFlatArrow color={Colours.PRIMARY} />
          </View>
        </View>
      </TouchableOpacity>

      {/* <Modal
        animationType="fade"
        visible={showUpdateProfilePage}
        onRequestClose={() => setShowUpdateProfilePage(false)}
      >
        <TopHeaderComponent
          headerText={"Update your profile"}
          hideScreen={() => setShowUpdateProfilePage(false)}
        />
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <UpdateProfilePage
            initialImage={image}
            setShowUpdateProfilePage={setShowUpdateProfilePage}
          />
        </ScrollView>
      </Modal>
      <Modal
        animationType="fade"
        visible={showAllTransactions}
        onRequestClose={() => setShowAllTransactions(false)}
      >
        <TopHeaderComponent
          headerText={"Transfer History"}
          hideScreen={() => setShowAllTransactions(false)}
        />
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <AllTransactionHistories />
        </ScrollView>
      </Modal>

      <Modal
        animationType="fade"
        visible={showSettings}
        onRequestClose={() => setShowSettings(false)}
      >
        <TopHeaderComponent headerText={"Settings"} hideScreen={() => setShowSettings(false)} />
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <SettingsPage />
        </ScrollView>
      </Modal>

      <Modal
        animationType="fade"
        visible={showFriendsListScreen}
        onRequestClose={() => setShowFriendsListScreen(false)}
      >
        <FriendsListScreen hideModal={() => setShowFriendsListScreen(false)} />
      </Modal> */}

      {/* <Modal
        animationType="fade"
        visible={showMyBrands}
        onRequestClose={() => setShowMyBrands(false)}
      >
        <TopHeaderComponent headerText={"My Brands"} hideScreen={() => setShowMyBrands(false)} />
        <BussinessPage hideModal={() => setShowMyBrands(false)} />
      </Modal> */}

      <Modal
        animationType="fade"
        visible={showFeedBacks}
        onRequestClose={() => setShowFeedBacks(false)}
      >
        <TopHeaderComponent
          headerText={"Feedback and support"}
          hideScreen={() => setShowFeedBacks(false)}
        />
        <FeedBackSupport hideModal={() => setShowFeedBacks(false)} />
      </Modal>

      <Modal
        visible={isWordNoticeVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setShowWordNotice(false)}
      >
        <WordNotice message={noticeMessage} onClose={() => setShowWordNotice(false)} />
      </Modal>

      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  // profileContainer2: {
  //   padding: dynamicSpacing(30),
  // },
  profileContainer2: {
    flex: 1,
    minHeight: "100%",
    padding: dynamicSpacing(30),
    backgroundColor: Colours.LIGHTEST,
  },
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
  },
  nameTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(16),
    marginTop: dynamicSpacing(10),
    fontFamily: "Sen-Bold",
  },
  nameTxt2: {
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(15),
    marginTop: dynamicSpacing(3),
    fontFamily: "Sen-Regular",
  },
  emailTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Medium",
  },
  errorMessageTxt: {
    color: "white",
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Bold",
  },
  textTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  profileHeaderContainer2: {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    height: dynamicSize(200),
  },
  userImage2: {
    width: dynamicSize(100),
    height: dynamicSize(100),
    borderRadius: dynamicSize(99),
  },
  profileDataContainer: {
    display: "flex",
    backgroundColor: "white",
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  errorMessage: {
    display: "flex",
    backgroundColor: "pink",
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  profileDataSubContainer: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
  },
  flatArrowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: dynamicSize(243),
  },
  amountForward: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
  },
});

export default ProfileBody;
